import React from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./confirmationModal.css";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you sure you want to cancel the booking?",
  confirmText = "Yes",
  cancelText = "No",
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={400}
      className="confirmation-modal"
      closable={true}
      closeIcon={<CloseOutlined />}
    >
      <div className="confirmation-modal-content">
        <h3 className="confirmation-modal-title">{title}</h3>

        <div className="modal-actions">
          <button className="modal-btn cancel-btn" onClick={onClose}>
            {cancelText}
          </button>
          <button
            className="modal-btn confirm-btn-cancel"
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
